import {
  Button,
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@bleu.builders/ui";
import { TicketCheck, UserRoundPlus } from "lucide-react";
import React from "react";

import { AlterPlanResourcesModal } from "./AlterPlanResourcesModal";
import { AssignTrialPlans } from "./AssignTrialPlans";
import { CancelPlanConfirmation } from "./CancelPlanConfirmation";
import { ManuallyAssignCreditsButton } from "./ManuallyAssignCreditsButton";
import { PlansTable } from "./PlansTable";

export const PlanActions = ({ organization }) => {
  return (
    <div className="flex flex-wrap justify-start gap-2 items-center rounded-md mr-10">
      <Dialog>
        <DialogTrigger asChild>
          <Button className="bg-primary/20 text-primary border border-primary hover:bg-primary/10">
            <TicketCheck size={16} className="mr-2" />
            Alterar plano
          </Button>
        </DialogTrigger>
        <DialogContent className="max-h-[90%] max-w-7xl overflow-auto">
          <PlansTable plans_type="subscription,installment_subscription" />
        </DialogContent>
      </Dialog>
      <div className="flex-100">
        <ManuallyAssignCreditsButton organization={organization} />
      </div>
      {organization.subscription?.status === "trialing" && (
        <AlterPlanResourcesModal organization={organization} />
      )}
      <Dialog>
        <DialogTrigger asChild>
          <Button className="bg-primary/20 text-primary border border-primary hover:bg-primary/10">
            <UserRoundPlus size={16} className="mr-2" />
            {organization.extra_seats_subscription ? "Alterar" : "Criar"}{" "}
            assinatura de Seats Extras
          </Button>
        </DialogTrigger>
        <DialogContent className="max-h-[90%] max-w-7xl overflow-auto">
          <PlansTable plans_type="extra_seats" />
        </DialogContent>
      </Dialog>
      <Dialog>
        <DialogTrigger asChild>
          <Button className="bg-primary/20 text-primary border border-primary hover:bg-primary/10">
            <UserRoundPlus size={16} className="mr-2" />
            {organization.reusable_diagnosis_link_creation_subscription
              ? "Alterar"
              : "Criar"}{" "}
            assinatura de criação de links de diagnóstico reutilizáveis
          </Button>
        </DialogTrigger>
        <DialogContent className="max-h-[90%] max-w-7xl overflow-auto">
          <PlansTable plans_type="reusable_diagnosis_link_creation" />
        </DialogContent>
      </Dialog>
      {organization.subscription && !organization.subscription?.canceled && (
        <div className="flex-100">
          <CancelPlanConfirmation organization={organization} />
        </div>
      )}
      {(!organization.subscription ||
        organization.subscription.status === "canceled") && (
        <>
          <AssignTrialPlans organization={organization} premium={false} />
          <AssignTrialPlans organization={organization} premium={true} />
        </>
      )}
    </div>
  );
};
